import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { IApiCentresServeis, IApiCentresServeiMunicipis } from "./api.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class ServeisSuports {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: ng.IHttpService,
  ) { }

  getCentresSuport(codiCentre: string): angular.IPromise<IApiCentresServeiMunicipis[]> {
    const config = { params: { codiCentre } };
    return this.$http
      .get<IApiCentresServeis>(`${this.apiUrl}/suports/findOfertaCentreSuports`, config)
      .then((response) => response.data.contingut)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return [];
      });
  }

  getCentresServeis(codiCentre: string): angular.IPromise<IApiCentresServeiMunicipis[]> {
    const config = { params: { codiCentre } };
    return this.$http
      .get<IApiCentresServeis>(`${this.apiUrl}/serveis/findOfertaCentreServeis`, config)
      .then((response) => response.data.contingut)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return [];
      });
  }
}

angularJsApp.service(AppServicesEnum.SERVEIS_SUPORTS, ServeisSuports);